var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.479,
    height: 18.098,
    viewBox: "0 0 14.479 18.098",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_99780e068729c39d8f9fdc023be03ba8",
    "data-name": "99780e068729c39d8f9fdc023be03ba8",
    d: "M1697.81,13.016a1.811,1.811,0,0,0-1.81,1.81V26.288a1.811,1.811,0,0,0,1.81,1.81h7.843a1.811,1.811,0,0,0,1.81-1.81.6.6,0,1,0-1.206,0,.606.606,0,0,1-.6.6h-7.843a.605.605,0,0,1-.6-.6V14.826a.605.605,0,0,1,.6-.6.6.6,0,0,0,0-1.207Zm12.669-1.207a1.811,1.811,0,0,0-1.81-1.81h-7.842a1.811,1.811,0,0,0-1.81,1.81V23.272a1.811,1.811,0,0,0,1.81,1.81h7.842a1.811,1.811,0,0,0,1.81-1.81Zm-1.206,0V23.272a.606.606,0,0,1-.6.6h-7.842a.605.605,0,0,1-.6-.6V11.81a.605.605,0,0,1,.6-.6h7.842a.606.606,0,0,1,.6.6Z",
    transform: "translate(-1696 -10)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.e751c4c055d679faff673cc5cc7dbe05.svg";
export { ForwardRef as ReactComponent };